import React from 'react';
import { Fade, Zoom } from 'react-reveal';
import styled from 'styled-components';

import { Flex, Text } from '../../../components';

import IconOne from '../../../assets/Features/1.png';
import IconTwo from '../../../assets/Features/2.png';
import IconThree from '../../../assets/Features/3.png';
import IconFour from '../../../assets/Features/4.png';
import IconFive from '../../../assets/Features/5.png';
import IconSix from '../../../assets/Features/6.png';

const Grid = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
  display: grid;
  width: 100%;
  max-width: 1200px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 360px));
  grid-gap: 20px;
`;

const Container = styled.div`
  background: #161930;
  border-radius: 8px;
  height: 100%;
  padding: 8% 12%;
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &:hover {
    transform: scale(1.05);
  }
`;

const features = [
  {
    icon: IconOne,
    name: 'Support',
    description:
      'We offer 24/7 support for all our members through our discord server!',
  },
  {
    icon: IconTwo,
    name: 'In-House Anti-Bot Protection',
    description:
      'We pride our-selves for our in-house ant-bot protetion solution. We are able to adapt to changes quicker and allow users to have a better experince!',
  },
  {
    icon: IconThree,
    name: 'User-Friendly Interface',
    description:
    'We know whats important to many people, and one of those things is a good user interface. We have designed a user interface that is both easy to use and informative on what going on!',
  },
  {
    icon: IconFour,
    name: 'Unlimited Task Support',
    description:
      'Trickle has been constructed to have great success and efficiency. We have spent a lot of time to ensure that you are able to run more task then you will ever need without affecting the performance of the bot!',
  },
  {
    icon: IconFive,
    name: 'Restock Mode',
    description:
      'Dont have time to sit by your computer all day? Trickle allows you to start your task and walk away from your computer. Trickle allows you to monitor for restocks so you are always able to checkout even when you are not around!',
  },
  {
    icon: IconSix,
    name: 'Proven Success',
    description:
      'Having success is important to us, which is why we had a long beta period with some of the best chefs in the community. We listen to their thoughts and observed their succes, which is why they trust trickle for all their botting needs!',
  },
];

const Feature = ({ icon, name, description }) => (
  <Container>
    <img src={icon} alt="" />
    <Flex h="10px" />
    <Text.Heading size="18">{name}</Text.Heading>
    <Flex h="16px" />
    <Text.Body size="14">{description}</Text.Body>
  </Container>
);

const Features = () => (
  <Flex id="features" dir="column" w="100%" align="center">
    <Zoom>
      <Text.Heading style={{ maxWidth: '90%' }} center size="36">
        The most advanced <span style={{ color: '#F73CC6' }}>features</span>
      </Text.Heading>
    </Zoom>

    <Flex h="110px" />
    <Grid>
      {features.map(feature => (
        <Fade up>
          <Feature key={feature.name} {...feature} />
        </Fade>
      ))}
    </Grid>
  </Flex>
);

export default Features;
